// extracted by mini-css-extract-plugin
export default {"releaseNavigationItem":"exKSwCyO","releaseContent":"PrBhHmuT"};